/**
 * 다른 창에서 「오라클 성능 분석 › 실행 이력」 으로 넘어가는 요청(2026-10-22 — 세션 분석의 커서·타임라인 SQL).
 *
 * 받는 쪽이 셋이다 — Header(창을 열고 앞으로), ConnTabsWindow(그 연결의 탭으로), 그 연결의 본문(실행 이력 탭에서 SQL 을 연다).
 * 창이 아직 닫혀 있으면 본문은 나중에 마운트되므로 요청은 **본문이 받을 때까지 남겨 둔다**(take). 같은 요청을 두 번 열지 않게 seq 로 가른다.
 */
import { useEffect, useState } from 'react';

let seq = 0;
let pending = null;            // { connId, sqlId, seq }
const subs = new Set();

export function requestPerfHistory(connId, sqlId) {
    if (!connId || !sqlId) return;
    pending = { connId, sqlId, seq: ++seq };
    subs.forEach(fn => fn(pending));
}

/** 그 연결의 요청이 남아 있으면 꺼내고 지운다 — 본문이 한 번만 연다 */
export function takePerfHistory(connId) {
    if (!pending || pending.connId !== connId) return null;
    const p = pending;
    pending = null;
    // 받았다고 알린다 — 남겨 두면 나중에 창을 다시 열 때 옛 요청의 연결로 시작한다
    setTimeout(() => subs.forEach(fn => fn(null)), 0);
    return p;
}

/** 지금 남아 있는 요청(없으면 null) — 새 요청이 오면 다시 그린다 */
export function usePerfJump() {
    const [req, setReq] = useState(pending);
    useEffect(() => {
        const fn = (r) => setReq(r);
        subs.add(fn);
        setReq(pending);
        return () => { subs.delete(fn); };
    }, []);
    return req;
}
